module.exports = __webpack_public_path__ + "img/Brainforce_1.525d009f.png";